import styled, { css } from 'styled-components';

const StatusBadge = styled.div<{ $variant: 'gray' | 'yellow' | 'red' | 'green' }>`
  ${(props) => props.theme.typography.headerCaptionMedium};
  border-radius: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  color: white;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  padding: 0.25rem 0.75rem;
  background-color: ${(props) => props.theme.colors.darkGray};

  ${(props) =>
    props.$variant === 'gray' &&
    css`
      color: ${(props) => props.theme.colors.primaryBlack80};
      background-color: ${(props) => props.theme.colors.statusLabelGrayBg};
    `}

  ${(props) =>
    props.$variant === 'yellow' &&
    css`
      color: ${(props) => props.theme.colors.statusLabelYellowText};
      background-color: ${(props) => props.theme.colors.statusLabelYellowBg};
    `}

  ${(props) =>
    props.$variant === 'red' &&
    css`
      color: ${(props) => props.theme.colors.statusLabelRedText};
      background-color: ${(props) => props.theme.colors.statusLabelRedBg};
    `}
  
    ${(props) =>
    props.$variant === 'green' &&
    css`
      color: ${(props) => props.theme.colors.statusLabelGreenText};
      background-color: ${(props) => props.theme.colors.statusLabelGreenBg};
    `}
`;
export default StatusBadge;
